import type { ComponentConfig } from "@puckeditor/core";
import { ComponentRef, type ComponentRefProps } from "./component-ref";

/**
 * Puck configuration for ComponentRef
 *
 * This component allows referencing shared SiteComponents by their UUID,
 * enabling global navigation and footer that can be edited once and
 * reflected across all pages.
 */
export const ComponentRefConfig: ComponentConfig<ComponentRefProps> = {
  label: "Component Reference",
  fields: {
    componentId: {
      type: "text",
      label: "Component ID",
    },
    componentType: {
      type: "radio",
      label: "Component Type",
      options: [
        { label: "Navigation", value: "navigation" },
        { label: "Footer", value: "footer" },
      ],
    },
  },
  defaultProps: {
    componentId: "",
    componentType: "navigation",
  },
  render: (props) => <ComponentRef {...props} />,
};
